import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CallMissedOutgoingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"call_missed_outgoing"}/>
}
